import { Link } from "react-router-dom";
import { JustDialURL } from "../constants/AppointmentConstant";

function AppointmentButtonGroup({ setTab }) {
  return (
    <div className="button-group">
      {/* Existing Book Appointment button */}
      <Link
        to="/appointment"
        className="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-fill ttm-btn-color-skincolor margin_top15"
        onClick={() => setTab("appointment")}
      >
        Book Appointment
      </Link>

      {/* New Book in JustDial Button Added*/}
      <a
        href={JustDialURL}
        target="_blank"
        rel="noopener noreferrer"
        className="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-border margin_top15 mx-1 justdial-btn"
      >
        Book in JustDial
      </a>
    </div>
  );
}

export default AppointmentButtonGroup;